import { routes as listingInquiryRoutes } from './listing-inquiry'
import { routes as multipostInquiryRoutes } from './multipost-inquiry'
import { routes as rentalInquiryRoutes } from './rental-inquiry'

export const routes = {
  ...listingInquiryRoutes,
  ...multipostInquiryRoutes,
  ...rentalInquiryRoutes,
}
